import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  updateDoc,
  deleteDoc,
  doc,
  getDoc
} from "firebase/firestore";
import { Liga } from "../models/types";

const ligasCollection = collection(db, "ligas");

export const LigaServiceFirestore = {
  async create(liga: Omit<Liga, "id">) {
    const docRef = await addDoc(ligasCollection, liga);
    return { ...liga, id: docRef.id };
  },

  async getAll(): Promise<Liga[]> {
    //console.log('DEBUG - LigaServiceFirestore - Obteniendo todas las ligas de Firestore...');
    try {
      const snapshot = await getDocs(ligasCollection);
      //console.log('DEBUG - LigaServiceFirestore - Número de documentos obtenidos:', snapshot.docs.length);
      
      const ligas = snapshot.docs.map(doc => {
        const data = doc.data();
        const liga = { id: doc.id, ...data } as Liga;
        //console.log(`DEBUG - LigaServiceFirestore - Liga cargada: ${liga.nombre}, ID: ${liga.id}`);
        return liga;
      });
      
      //console.log('DEBUG - LigaServiceFirestore - Total ligas cargadas:', ligas.length);
      return ligas;
    } catch (error) {
      console.error('ERROR - LigaServiceFirestore - Error al obtener ligas:', error);
      return [];
    }
  },

  async getById(id: string): Promise<Liga | null> {
    const docRef = doc(db, "ligas", id);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      return { id: docSnap.id, ...docSnap.data() } as Liga;
    }
    return null;
  },

  async update(id: string, ligaData: Partial<Liga>) {
    const docRef = doc(db, "ligas", id);
    await updateDoc(docRef, ligaData);
  },

  async delete(id: string) {
    const docRef = doc(db, "ligas", id);
    await deleteDoc(docRef);
  }
};
